import { h, Fragment } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import { withCartContext } from './cart-context';
import IconClose from '../utils/icon/close.svg';

const CartErrorModal = (props) => {
  const { data } = props;
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleShowModal = () => {
      setIsVisible(true);
    };

    window.addEventListener('cart:open-error-modal', handleShowModal);

    return () => {
      window.removeEventListener('cart:open-error-modal', handleShowModal);
    };
  }, []);

  const closeModal = () => setIsVisible(false);

  return (
    isVisible && (
      <>
        <div className="fixed top-0 left-0 w-full h-full bg-[#0000004D] backdrop-blur-[5px] z-50"></div>
        <div className="fixed top-0 left-0 right-0 bottom-0 w-max max-w-[90%] h-max rounded-[5px] bg-neutral px-[31px] py-[30px] z-[51] m-auto text-center">
          <button
            className="absolute top-[12px] right-[10px]"
            onClick={closeModal}
          >
            <IconClose />
          </button>
          <div className="font-hoefler text-[20px] leading-6 uppercase mb-[10px]">
            {data.quantityErrorTitle}
          </div>
          <div
            className="font-gotham text-[13px] leading-[18px] max-w-[420px]"
            dangerouslySetInnerHTML={{ __html: data.quantityErrorMessage }}
          ></div>
          <button className="btn-primary mt-[30px]" onClick={closeModal}>
            Close
          </button>
        </div>
      </>
    )
  );
};

export default withCartContext(CartErrorModal);
